module.exports = __webpack_public_path__ + "img/dostupno.cb326d0f.png";